module.exports = __webpack_public_path__ + "img/akqa-late-nights.3072b0a7.jpg";